import { render, staticRenderFns } from "./Detalhes_Unidade.vue?vue&type=template&id=4933857f&"
import script from "./Detalhes_Unidade.vue?vue&type=script&lang=js&"
export * from "./Detalhes_Unidade.vue?vue&type=script&lang=js&"
import style0 from "./Detalhes_Unidade.vue?vue&type=style&index=0&id=4933857f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports